'use client';

import { Cloud, Home } from 'lucide-react';
import { ThemeToggle } from '@/components/ui/theme-toggle';

export default function CloudPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950">
      {/* 헤더 */}
      <header className="sticky top-0 z-50 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Cloud className="h-6 w-6 text-blue-500" />
            <span className="font-semibold text-gray-900 dark:text-gray-100">
              Kamibot Cloud
            </span>
          </div>
          <ThemeToggle />
        </div>
      </header>

      {/* 메인 컨텐츠 */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="max-w-md mx-auto text-center">
          <div className="p-8 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-2xl border border-blue-200 dark:border-blue-700 shadow-sm">
            <Cloud className="h-16 w-16 text-blue-500 mx-auto mb-4 animate-bounce" />
            <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400 bg-clip-text text-transparent mb-3">
              카미봇 클라우드에 오신 것을 환영해요! ☁️
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              이 서비스는 <span className="font-semibold text-indigo-600 dark:text-indigo-400">Discord 카미봇</span>을 통해 대용량 파일을 쉽게 공유할 수 있는 공간이에요. 무려 100GB까지 업로드할 수 있답니다! 모든 것은 무료로 제공되며, 회원가입도 필요 없어요.
            </p>
            <div className="bg-white/60 dark:bg-gray-800/60 rounded-xl p-4 mb-6">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                파일을 업로드하려면 Discord에서 아래 명령어를 사용해 주세요:
              </p>
              <code className="inline-block bg-indigo-100 dark:bg-indigo-800/50 text-indigo-700 dark:text-indigo-300 px-3 py-1.5 rounded-lg font-mono text-base">
                /upload
              </code>
            </div>
            <div className="flex flex-col gap-3">
              <a
                href="https://kamibot.app/"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white font-medium rounded-xl shadow-md hover:shadow-lg transition-all duration-200"
              >
                <Home className="h-4 w-4" />
                <span>카미봇 홈페이지 방문하기</span>
              </a>
              <a
                href="https://discord.com/oauth2/authorize?client_id=1019061779357245521&prompt=none&scope=applications.commands&integration_type=1"
                rel="noopener noreferrer"
                className="inline-flex flex-col items-center justify-center px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white font-medium rounded-xl shadow-md hover:shadow-lg transition-all duration-200"
              >
                <span>나도 /upload 사용해보기</span>
                <span className="text-xs text-white/60 font-normal">카미봇이 없어도 사용 가능해요</span>
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* 푸터 */}
      <footer className="mt-auto py-6 text-center text-sm text-gray-500 dark:text-gray-400">
        <p>Powered by Kamibot</p>
      </footer>
    </div>
  );
}
